import { NgModule } from '@angular/core';
import { provideProducts } from './token-product-config';
import { reiseAuslandsKrankenversicherung } from './travel/product';
import { tabletVersicherungPlus } from './tablet-plus/config/tablet-versicherung-plus';
import { musicInstrumentInsuranceForSchools } from './music-instrument-schools/config/product';
import { musikinstrumentenversicherungPremium } from '../products/music-instrument-premium/config/product';
import { ProductWithVariants } from '@models/product';
import { accidentInsuranceForPupils } from './accident-pupils/config';
import {
    fahhradSchuelerOld,
    schuelerSachschadenUndHaftpflicht,
    schuelerKombischutzJ,
    schuelerKombischutzM,
    tabletSchueler,
    xxlKombischutzJ,
    xxlKombischutzM,
} from './legacy/legacy-products';
import { musicInstrumentInsuranceForPupils } from './music-instrument-pupils/config';
import { travelInsuranceForPupils } from './travel-pupils/config';
import { tutoringInsurance } from './tutoring/config';
import { bikeProduct } from './bike/config/product';
import { electronicsB2CProduct } from './electronic/config/electronics-b2c-product.config';
import { electronicsB2BProduct } from './electronic/config/electronics-b2b-product.config';
import { handyProduct } from './electronic/config/handy-product.config';
import { OrderModule } from 'app/order/order.module';

const products: ProductWithVariants[] = [
    tabletVersicherungPlus,
    electronicsB2CProduct,
    handyProduct,

    // legacy products:
    fahhradSchuelerOld,
    schuelerSachschadenUndHaftpflicht,
    schuelerKombischutzJ,
    schuelerKombischutzM,
    tabletSchueler,
    xxlKombischutzJ,
    xxlKombischutzM,
    musicInstrumentInsuranceForSchools,
    bikeProduct,
    travelInsuranceForPupils,
    musikinstrumentenversicherungPremium,
    musicInstrumentInsuranceForPupils,
    accidentInsuranceForPupils,
    tutoringInsurance,
    reiseAuslandsKrankenversicherung,
    electronicsB2BProduct,
];

@NgModule({
    imports: [OrderModule],
    providers: [provideProducts(products)],
})
export class ProductsModule {}
